import request from '@/service/request'

// 获取字典类型列表
export function getDataDictionaryTypeService(data) {
    return request.post('/v3/dataDictionary/getTypeList', data);
}

// 添加字典项
export function createDataDictionaryService(data) {
    return request.post('/v3/dataDictionary/add', data);
}

// 更新字典项
export function updateDataDictionaryService(data) {
    return request.put('/v3/dataDictionary/update', data);
}

// 删除字典项
export function deleteDataDictionaryByIdService(id) {
    return request.delete(`/v3/dataDictionary/delete/${id}`);
}

// 批量删除字典项
export function batchDeleteDataDictionaryService(data) {
    return request.delete('/v3/dataDictionary/batchDelete', { data });
}

// 删除字典项校验
export function deleteDataDictionaryCheckService(data) {
    return request.delete('/v3/dataDictionary/delete/check', { data });
}

// 获取字典项列表
export function getDataDictionaryService(data) {
    return request.post('/v3/dataDictionary/getList', data);
}

// 导入字典项
export function importDataDictionaryService(data) {
    return request.post('/v3/dataDictionary/import', data);
}
